import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

import { LoadingService } from './../../loading';

import { FileRef } from '@shared/data';

@Component({
  selector: 'file-manager',
  styles: [require('./file-manager.component.scss')],
  template: require('./file-manager.component.html'),
  encapsulation: ViewEncapsulation.None
})
export class FileManagerComponent implements OnInit {
  constructor() {

  }

  public ngOnInit() {

  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+file-manager/file-manager.component.ts